// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.demo-look {
  --demo-look-line: color-mix(in srgb, var(--brand-primary, #0877bc) 22%, var(--border-color, rgba(0, 0, 0, 0.08)));
  margin: 0 20px 18px;
  padding: 1.15rem 1.25rem 1.2rem;
  border-radius: 18px;
  border: 1px solid var(--demo-look-line);
  background:
    linear-gradient(
      165deg,
      color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color, #fff)) 0%,
      var(--surface-color, #fff) 58%
    );
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.04),
    0 12px 28px rgba(15, 23, 42, 0.05);
}

.demo-look__kicker {
  margin: 0 0 0.2rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--brand-primary, #0877bc);
}

.demo-look__title {
  margin: 0 0 0.35rem !important;
  font-size: 1.15rem !important;
  font-weight: 720 !important;
  letter-spacing: -0.02em;
  color: var(--text-color, #111827);
}

.demo-look__lead,
.demo-look__hint {
  margin: 0;
  color: var(--text-secondary, #4b5563);
  line-height: 1.5;
  font-size: 0.92rem;
}

.demo-look__lead {
  max-width: 46rem;
  margin-bottom: 1rem;
}

.demo-look__hint {
  margin-top: 0.85rem;
}

.demo-look__row {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  flex-wrap: wrap;
}

.demo-look__select {
  flex: 1 1 16rem;
  min-width: 12rem;
  max-width: 28rem;
}

.demo-look__preview {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-top: 0.85rem;
  padding: 0.55rem 0.75rem;
  border-radius: 12px;
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, var(--surface-color, #fff));
  border: 1px solid var(--demo-look-line);
}

.demo-look__preview-label {
  color: var(--text-secondary, #4b5563) !important;
  font-size: 0.88rem !important;
}

.demo-look__preview-label strong {
  color: var(--text-color, #111827);
  font-weight: 650;
}

.demo-look__swatches {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  flex-shrink: 0;
}

.demo-look__swatch {
  width: 1.15rem;
  height: 1.15rem;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--text-color, #111827) 12%, transparent);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12);
}

.demo-look__logo-slot {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, transparent);
  border: 1px dashed var(--demo-look-line);
  flex-shrink: 0;
}

@media (max-width: 720px) {
  .demo-look {
    margin: 0 12px 14px;
    padding: 1rem;
  }

  .demo-look__row {
    align-items: stretch;
  }

  .demo-look__select {
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DemoClubLookCard.css"],"names":[],"mappings":"AAAA;EACE,iHAAiH;EACjH,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,uCAAuC;EACvC;;;;;KAKG;EACH;;sCAEoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;;EAEE,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,4FAA4F;EAC5F,uCAAuC;AACzC;;AAEA;EACE,gDAAgD;EAChD,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,iFAAiF;EACjF,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8EAA8E;EAC9E,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".demo-look {\n  --demo-look-line: color-mix(in srgb, var(--brand-primary, #0877bc) 22%, var(--border-color, rgba(0, 0, 0, 0.08)));\n  margin: 0 20px 18px;\n  padding: 1.15rem 1.25rem 1.2rem;\n  border-radius: 18px;\n  border: 1px solid var(--demo-look-line);\n  background:\n    linear-gradient(\n      165deg,\n      color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color, #fff)) 0%,\n      var(--surface-color, #fff) 58%\n    );\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.04),\n    0 12px 28px rgba(15, 23, 42, 0.05);\n}\n\n.demo-look__kicker {\n  margin: 0 0 0.2rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--brand-primary, #0877bc);\n}\n\n.demo-look__title {\n  margin: 0 0 0.35rem !important;\n  font-size: 1.15rem !important;\n  font-weight: 720 !important;\n  letter-spacing: -0.02em;\n  color: var(--text-color, #111827);\n}\n\n.demo-look__lead,\n.demo-look__hint {\n  margin: 0;\n  color: var(--text-secondary, #4b5563);\n  line-height: 1.5;\n  font-size: 0.92rem;\n}\n\n.demo-look__lead {\n  max-width: 46rem;\n  margin-bottom: 1rem;\n}\n\n.demo-look__hint {\n  margin-top: 0.85rem;\n}\n\n.demo-look__row {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  flex-wrap: wrap;\n}\n\n.demo-look__select {\n  flex: 1 1 16rem;\n  min-width: 12rem;\n  max-width: 28rem;\n}\n\n.demo-look__preview {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  margin-top: 0.85rem;\n  padding: 0.55rem 0.75rem;\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, var(--surface-color, #fff));\n  border: 1px solid var(--demo-look-line);\n}\n\n.demo-look__preview-label {\n  color: var(--text-secondary, #4b5563) !important;\n  font-size: 0.88rem !important;\n}\n\n.demo-look__preview-label strong {\n  color: var(--text-color, #111827);\n  font-weight: 650;\n}\n\n.demo-look__swatches {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  flex-shrink: 0;\n}\n\n.demo-look__swatch {\n  width: 1.15rem;\n  height: 1.15rem;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, var(--text-color, #111827) 12%, transparent);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12);\n}\n\n.demo-look__logo-slot {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, transparent);\n  border: 1px dashed var(--demo-look-line);\n  flex-shrink: 0;\n}\n\n@media (max-width: 720px) {\n  .demo-look {\n    margin: 0 12px 14px;\n    padding: 1rem;\n  }\n\n  .demo-look__row {\n    align-items: stretch;\n  }\n\n  .demo-look__select {\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
